<template>
  <div class="profile-page page">
    <van-nav-bar
      :title="pageTitle"
      class="nav-bar"
    >
      <template #left>
        <van-icon name="arrow-left" @click="back()" />
      </template>
      <template #right>
        <van-icon name="service-o" class="nav-service" @click="toService()" />
      </template>
    </van-nav-bar>

    <div class="profile-scroll">
      <div class="hero-wrap" v-if="slides.length">
        <swiper class="hero-swiper" :options="swiperOption">
          <swiper-slide v-for="(img, k) in slides" :key="k">
            <img :src="mediaUrl(img)" alt="" />
          </swiper-slide>
        </swiper>
        <span class="hero-premium"><i>{{ $t('home.gaoji') }}</i></span>
        <div class="hero-footer">
          <div class="hero-verify">
            <span><i class="verify-icon">V</i>{{ $t('home.smrz') }}</span>
            <span><i class="verify-icon">V</i>{{ $t('home.videorz') }}</span>
          </div>
        </div>
      </div>

      <div class="intro-section">
        <h2 class="section-title">{{ $t('index.beauty_profile') }}</h2>
        <p class="intro-line" v-if="xuanfeidata.sg || xuanfeidata.xw">
          {{ $t('home.sg') }}: {{ xuanfeidata.sg || '-' }}cm
          &nbsp;&nbsp;{{ $t('home.xw') }}: {{ xuanfeidata.xw || '-' }}
        </p>
        <p class="intro-line star-line">
          {{ $t('home.star') }}：
          <span class="star" v-for="n in starCount" :key="n"></span>
        </p>
        <p class="intro-line">
          {{ $t('index.mobile_label') }}：{{ $t('index.possible') }}
        </p>
        <a class="verify-btn" @click="toService">{{ $t('index.click_verify') }}</a>
      </div>

      <div class="detail-section">
        <h2 class="section-title">{{ $t('index.detail_info') }}</h2>
        <p class="detail-desc" v-if="detailText">{{ detailText }}</p>
        <ul class="detail-gallery" v-if="slides.length">
          <li v-for="(img, k) in slides" :key="'d-' + k">
            <img :src="mediaUrl(img)" alt="" />
          </li>
        </ul>
        <div class="video-box" v-if="videoUrl">
          <video :src="mediaUrl(videoUrl)" controls></video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      xuanfeidata: {},
      swiperOption: {
        autoplay: { delay: 3000, disableOnInteraction: false },
        loop: true
      }
    }
  },
  computed: {
    pageTitle() {
      return this.$t('choose.nav')
    },
    slides() {
      const imgs = this.xuanfeidata.img_url
      if (Array.isArray(imgs)) return imgs
      if (typeof imgs === 'string' && imgs) return [imgs]
      return []
    },
    detailText() {
      return (this.xuanfeidata.jianjie || '').trim()
    },
    videoUrl() {
      return this.xuanfeidata.pvideo || this.xuanfeidata.video_url || ''
    },
    starCount() {
      const n = parseInt(this.xuanfeidata.number || this.xuanfeidata.star, 10)
      return n > 0 ? Math.min(n, 5) : 5
    }
  },
  methods: {
    mediaUrl(url) {
      if (!url) return ''
      if (/^https?:\/\//i.test(url)) return url
      const base = process.env.NODE_ENV === 'development' ? '' : 'https://d2h0m7gk9kbvfa.cloudfront.net'
      return url.startsWith('/') ? `${base}${url}` : `${base}/${url}`
    },
    back() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace({ path: '/Choose' })
      }
    },
    toService() {
      const service = this.$store.getters.getBaseInfo
      if (service && service.iskefu == 1) {
        this.$router.push({ path: '/ServiceOnline' })
      } else {
        this.$router.push({ path: '/ServicePage' })
      }
    },
    getxuanfeidata() {
      this.$http({
        method: 'get',
        url: 'xuanfeidata',
        data: { id: this.$route.query.id }
      }).then(res => {
        this.xuanfeidata = res.data || {}
        if (this.slides.length <= 1) {
          this.swiperOption = { ...this.swiperOption, loop: false, autoplay: false }
        }
      })
    }
  },
  created() {
    this.getxuanfeidata()
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.profile-page {
  background: #fff;
}

.nav-service {
  font-size: 1.25rem;
  color: #fff;
}

.profile-scroll {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.hero-wrap {
  position: relative;
  width: 100%;
}

.hero-swiper {
  width: 100%;
}

::v-deep .hero-swiper .swiper-slide {
  height: 28rem;
  overflow: hidden;
}

::v-deep .hero-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.hero-premium {
  position: absolute;
  z-index: 8;
  top: -5.33rem;
  right: -8.67rem;
  width: 10rem;
  height: 10rem;
  background: #ebcaaf;
  transform: rotate(45deg);
  opacity: 0.85;
  pointer-events: none;
}

.hero-premium i {
  position: absolute;
  bottom: 0;
  left: 1.83rem;
  color: #8d684b;
  font-weight: 600;
  font-style: normal;
  font-size: 0.85rem;
}

.hero-footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  min-height: 2.67rem;
  padding: 0.45rem 0.5rem 0.45rem 0.75rem;
  background: rgba(0, 0, 0, 0.9);
  border-radius: 1.67rem 1.67rem 0 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
}

.hero-tag {
  flex-shrink: 0;
  max-width: 38%;
  padding: 0.18rem 0.75rem;
  background: rgba(0, 0, 0, 0.55);
  border-radius: 1rem;
  color: #fff;
  font-size: 0.82rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hero-verify {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.18rem;
}

.hero-verify span {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  padding: 0.18rem 0.45rem;
  font-size: 0.72rem;
  border-radius: 0.25rem;
  white-space: nowrap;
}

.verify-icon {
  font-style: normal;
  margin-right: 0.12rem;
  font-size: 0.68rem;
}

.name-bar {
  text-align: center;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.85rem 0.75rem;
  color: #fff;
  background-image: linear-gradient(-244deg, #b465da, #cf6cc9 33%, #ee609c 66%, #ee609c);
}

.intro-section {
  position: relative;
  text-align: left;
  padding: 0.75rem 0.85rem 2.8rem;
  background: #fff;
}

.section-title {
  margin: 0 0 0.55rem;
  color: #000;
  font-size: 1.07rem;
  font-weight: 700;
}

.intro-line {
  margin: 0.35rem 0;
  font-size: 0.83rem;
  color: #333;
  line-height: 1.5;
}

.star-line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.star {
  width: 1rem;
  height: 1rem;
  margin-right: 2px;
  background: url(/img/star.png) no-repeat 50%/100%;
}

.verify-btn {
  position: absolute;
  right: 0.85rem;
  bottom: 0.85rem;
  color: #fff;
  padding: 0.35rem 0.95rem;
  background: linear-gradient(20deg, #e73266, #ee5380);
  border-radius: 0.33rem;
  font-size: 0.88rem;
  white-space: nowrap;
}

.detail-section {
  padding: 0.25rem 0 1.5rem;
  background: #fff;
}

.detail-section .section-title {
  padding: 0 0.85rem;
}

.detail-desc {
  margin: 0.35rem 0.85rem 0.5rem;
  font-size: 0.83rem;
  color: #666;
  line-height: 1.6;
  white-space: pre-wrap;
}

.detail-gallery {
  list-style: none;
  margin: 0;
  padding: 0;
}

.detail-gallery li {
  margin: 0;
}

.detail-gallery img {
  width: 100%;
  display: block;
  vertical-align: top;
}

.video-box {
  padding: 0.75rem 0.85rem 0;
}

.video-box video {
  width: 100%;
  border-radius: 8px;
  background: #000;
}
</style>
